export default __webpack_public_path__ + "static/media/D_Decor Home Fabrics Private Limited .b670d83d.jpg";